import { ListBox } from "primereact/listbox";
import { useEffect, useState } from "react";
import CatService from "../../service/CatService";
import { CommonDialog } from "../common/CommonDialog";

export function CatSelectList({parentId,catType,multiple,onSelect})
{
    const [cats,setCats]=useState([]);
    const [selectedCats,setSelectedCats]=useState([]);

    useEffect(()=>{
        CatService.getCatTree(parentId,catType).then((ret)=>{
            setCats(ret);
        });
    },[]);

    const onChange=(e)=>{
        setSelectedCats(e.value)
        if(onSelect)
            onSelect(e.value);
    };
    const itemTemplate=(item)=>{
        return item.name;
    };
    return(
        <ListBox options={cats} multiple={multiple} filter filterBy="path,name" 
            value={selectedCats} onChange={onChange} itemTemplate={itemTemplate} style={{overflow:'auto',height:'32rem',width:'40rem'}}></ListBox>
    );    
}
export function CatSelectListDialog({parentId,catType,visible,onOK,onCancel})
{
    const [cat,setCat] = useState(null);

    const onSelect=(cat)=>{setCat(cat)}
    const _onOK=()=>{
        onOK(cat);
    }
    const _onCancel=()=>{onCancel()}
    return(
        <CommonDialog visible={visible} onOK={_onOK} onCancel={_onCancel}>
			<CatSelectList parentId={parentId} catType={catType} onSelect={onSelect}/>					            
        </CommonDialog>    
    )
}